import { Filter } from './pagination.interface';

export interface PaginationFilters {
    filters: FilterCategory[];
    selectedItems: SelectedFilterItem[];
}

export interface FilterCategory {
    name: string;
    options: FilterItem[];
    selectedItems: SelectedFilterItem[];
}

export interface FilterItem {
    label: string;
    count: string;
    paginationFilter: Filter;
}

export interface SelectedFilterItem {
    categoryLabel?: string;
    label: string;
    filterIfRemoved: Filter;
}

export interface SearchFilter {
    search: string;
}
